// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"f6c5b020","608":"77db9d52","771":"bfc57e2a"}[chunkId] + ".chunk.css";
};